import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RmNormalizadorService } from '../../services/rm-normalizador.service';
import { RmRateService } from '../../services/rm-rate.service';
import { RepublicaMovilService } from '../../services/republica-movil.service';
import { Router } from '@angular/router';
import { iccidValidator } from '../../../utils/validators/iccid-validator';
import { MustMatch } from '../../../utils/validators/email-confirm-validator';
import { MatStepper } from '@angular/material/stepper';
import { RmOrderService } from '../../services/rm-order.service';
import { RmUserDataService } from '../../services/rm-user-data.service';
import { RmConfirmationService } from '../../services/rm-confirmation.service';
import { RmShoppingCartService } from '../../services/rm-shopping-cart.service';
import { orderType, realTechnologyNames } from 'src/app/shared/constantes';
import { RmDraftService } from '../../services/rm-draft.service';
import { RmMovilPackService } from '../../services/rm-movil-pack.service';
import { NotMustMatch } from 'src/app/utils/validators/not-much-match-validator';
import { NormalizadorService } from '../../../amena/services/normalizador.service';
import { environment } from '../../../../environments/environment';
import { HomeService } from '../../../home/services/home.service';
import { HmRateService } from "../../../home/services/hm-rate.service";
import { UserNotFoundComponent } from 'src/app/shared/components/user-not-found/user-not-found.component';
import { MatDialog } from '@angular/material/dialog';
import { RmModalIccidComponent } from '../rm-modal-iccid/rm-modal-iccid.component';
import { DigoService } from 'src/app/services/digo.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
    selector: 'app-republica-movil',
    encapsulation: ViewEncapsulation.Emulated,
    templateUrl: './republica-movil.component.html',
    styleUrls: ['./republica-movil.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})

export class RepublicaMovilComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('stepper') stepper: MatStepper;

    public isLoading = false;
    public isEditable = true;
    public finished = false;
    public rate: any;
    public mobileRates: any;
    public muestraNormalizacion = true;
    public typeOrder = '';
    public order;
    public enviroment = environment;
    public pdv;

    // Forms para los steps
    public fibraFormGroup: FormGroup;
    public movilPackFormGroup: FormGroup;
    public movilPackForms: FormArray;
    public clienteFormGroup: FormGroup;
    public confirmacionFormGroup: FormGroup;
    // Forms para los componentes
    public normalizadorFormGroup: FormGroup;
    public coberturaFormGroup: FormGroup;
    private maxAdditionalRates = 5;
    private preventDestroy = false;
    public muestraErrorPeticion = false;
    public msgErrorPeticion: string = null;
    public thereIsCoverage = false;
    public amenaRealtechnology: any;
    public orderType = orderType;
    public realTechnologyNames = realTechnologyNames;
    public resultadoCoberturaAmena: any;
    private allSubscription: Subscription[] = [];

    get baseUrl(): string {
        return this.auth.getLegacyBaseUrl();
    }

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private orderService: RmOrderService,
        private rateService: RmRateService,
        private rmService: RepublicaMovilService,
        private userDataService: RmUserDataService,
        private amNormalizadorService: NormalizadorService,
        private normalizadorService: RmNormalizadorService,
        private confirmationService: RmConfirmationService,
        private shoppingCartService: RmShoppingCartService,
        private movilPackService: RmMovilPackService,
        private draftService: RmDraftService,
        private homeService: HomeService,
        private hmRateService: HmRateService,
        public dialog: MatDialog,
        private digoService: DigoService,
        private auth: AuthService,
    ) {
        this.defineTypeOrder();
    }

    ngOnInit(): void {
        this.initComponent();
    }

    ngAfterViewInit() {
        this.shoppingCartService.setStepper(this.stepper);
        this.listenDraftServices();
    }

    initComponent() {
        this.allSubscription.push(this.rmService.getPreventDestroy()
            .subscribe((data: boolean) => {
                this.preventDestroy = data;
            })
        );

        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                if (data != null) {
                    this.typeOrder = data;
                }
            })
        );

        this.initForms();
        this.getMasters();

        this.allSubscription.push(this.rmService.getRateFtth()
            .subscribe((data: any) => {
                if (data != null) {
                    this.rate = data;
                    // this.maxAdditionalRates = this.rate.maxConvergentRates + this.rate.maxAdditionalRates;
                    this.fibraFormGroup.get('rate').patchValue(data);
                    this.orderService.setBroadbandRate(this.rate);
                    // this.movilPackService.setAllowAddAdditionalLines(this.movilPackForms.length < this.maxAdditionalRates);
                } else {
                    this.rate = null;
                    if (this.typeOrder === orderType.CONVERGENT && this.mobileRates && this.mobileRates.length > 0) {
                        this.rmService.removeFirstRatesMobile();
                    }

                    this.fibraFormGroup.get('rate').patchValue(null);
                }
            })
        );

        this.allSubscription.push(this.rmService.getRatesMobile()
            .subscribe((data: any) => {
                this.mobileRates = data;
            })
        );

        this.allSubscription.push(this.normalizadorService.getMuestraNormalizacion()
            .subscribe((value) => {
                this.muestraNormalizacion = value;

                if (this.muestraNormalizacion) {
                    this.rate = null;
                    this.fibraFormGroup.get('rate').patchValue(null);
                }
            })
        );

        this.allSubscription.push(this.normalizadorService.getResultadoCobertura()
            .subscribe((data: any) => {
                if (data != null) {
                    this.orderService.setBroadbandCoverage(data.getRawValue());
                }
            })
        );

        this.allSubscription.push(this.rmService.getMobilePacks()
            .subscribe((data: any) => {
                if (data != null) {
                    this.orderService.setMobiles(data);
                }
            })
        );

        this.allSubscription.push(this.userDataService.getUserData()
            .subscribe((data: any) => {
                if (data != null) {
                    this.orderService.setUserData(data);
                }
            })
        );

        this.allSubscription.push(this.confirmationService.getFinished()
            .subscribe((data: boolean) => {
                this.finished = data;
                this.isEditable = !this.finished;
            })
        );

        // Iniciar tramitación desde otra
        this.allSubscription.push(this.rmService.getUserData()
            .subscribe((data: any) => {
                if (data != null) {
                    this.clienteFormGroup.patchValue(data);
                }
            })
        );

        // Retomar borrador
        this.allSubscription.push(this.rmService.getFormsData()
            .subscribe((data: any) => {
                if (data != null) {
                    if (data.normalizador != null) {
                        this.normalizadorFormGroup.patchValue(data.normalizador);
                        this.normalizadorService.setFormularioNormalizacion(this.normalizadorFormGroup);
                    }

                    if (data.cobertura != null) {
                        if (!data.haveCoverage) {
                            data.cobertura.resultadoConsultaCobertura = null;
                        }
                        this.coberturaFormGroup.patchValue(data.cobertura);
                        this.normalizadorService.setResultadoCobertura(this.coberturaFormGroup);
                    }

                    if (data.fibra != null) {
                        this.fibraFormGroup.patchValue(data.fibra);
                        this.rmService.setRateFtth(data.fibra.rate);
                        if (data.haveCoverage) {
                            this.normalizadorService.setMuestraNormalizacion(false);
                            this.normalizadorService.setMuestraBotonNormalizacion(false);
                            this.normalizadorService.setMuestraCobertura(true);
                            this.normalizadorService.setThereIsCoverage(true);
                        } else {
                            this.normalizadorService.setMuestraNormalizacion(true);
                            this.normalizadorService.setMuestraBotonNormalizacion(true);
                            this.normalizadorService.setMuestraCobertura(false);
                            this.normalizadorService.setThereIsCoverage(false);
                        }
                    }

                    if (data.movilPacks != null && data.movilPacks.length > 0 && this.typeOrder !== orderType.BROADBAND) {
                        data.movilPacks.forEach((movilPack: any, index: number) => {
                            if (!this.movilPackForms.controls[index]) {
                                this.movilPackForms.insert(index, this.setMobilePack());
                            }
                            const movilPackForm: any = this.movilPackForms.controls[index];
                            movilPackForm.patchValue(movilPack);
                            if (movilPack.rate && movilPack.rate) {
                                this.rmService.setRatesMobile(index, movilPack.rate);
                            }
                            this.rmService.setMobilePacks(index, movilPackForm.getRawValue());
                        });
                    }

                    if (data.cliente != null) {
                        if (!data.haveCoverage) {
                            data.cliente.nombreVia = '';
                            data.cliente.numero = '';
                            data.cliente.planta = '';
                            data.cliente.puerta = '';
                            data.cliente.escalera = '';
                            data.cliente.codigoPostal = '';
                            data.cliente.localidad = '';
                            data.cliente.provincia = '';
                        }
                        this.clienteFormGroup.patchValue(data.cliente);
                        if (data.disabledCliente) {
                            this.clienteFormGroup.get('doctype').disable();
                            this.clienteFormGroup.get('doc').disable();
                            this.clienteFormGroup.get('country').disable();
                            this.clienteFormGroup.get('firstName').disable();
                            this.clienteFormGroup.get('surname1').disable();
                            this.clienteFormGroup.get('surname2').disable();
                            this.clienteFormGroup.get('birthday').disable();
                            this.clienteFormGroup.get('sex').disable();
                            this.clienteFormGroup.get('company').disable();
                            if (this.typeOrder !== orderType.BROADBAND) {
                                this.dialog.open(RmModalIccidComponent, {
                                    width: '425px',
                                    disableClose: true,
                                    data: { }
                                });
                            }
                        }
                        this.userDataService.setUserData(this.clienteFormGroup.getRawValue());
                    }
                }
            })
        );

        this.allSubscription.push(this.rmService.getIndexToRemove()
            .subscribe(data => {
                if (data) {
                    this.removeAdditionalLine(data);
                }
            })
        );

        this.allSubscription.push(this.draftService.getUpdateDraft()
            .subscribe((update) => {
                if (update) {
                    this.updateOrderWithLastChanges();
                }
            })
        );

        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((order) => {
                this.order = order;
            })
        );

        // Errores petición http o direcciones vacias
        this.allSubscription.push(this.normalizadorService.getErrorPeticionCobertura()
            .subscribe((value: any) => {
                this.muestraErrorPeticion = value;
            })
        );

        this.allSubscription.push(this.normalizadorService.getMsgErrorCobertura()
            .subscribe((value: any) => {
                this.msgErrorPeticion = value;
            })
        );

        this.allSubscription.push(this.normalizadorService.getThereIsCoverage()
            .subscribe((value: any) => {
                this.thereIsCoverage = value;
            })
        );

        this.allSubscription.push(this.amNormalizadorService.getRealtechnology()
            .subscribe((data: any) => {
                this.amenaRealtechnology = data;
            })
        );

        this.allSubscription.push(this.normalizadorService.getResultadoCoberturaAmena()
            .subscribe((data: any) => {
                if (data != null) {
                    this.resultadoCoberturaAmena = data;
                }
            })
        );

        this.allSubscription.push(this.digoService.getPDV()
            .subscribe(data => {
                if (data) {
                    this.pdv = data;
                }
            })
        );
    }

    initForms() {
        this.fibraFormGroup = this.formBuilder.group({
            rate: ['', Validators.required]
        });
        let arrayForms = [];
        if (this.typeOrder !== orderType.BROADBAND) {
            arrayForms = [this.setMobilePack()];
        }
        this.movilPackForms = this.formBuilder.array(arrayForms);
        this.movilPackFormGroup = this.formBuilder.group({
            form: this.movilPackForms
        });
        this.clienteFormGroup = this.formBuilder.group({
            doctype: ['', Validators.required],
            doc: ['', Validators.required],
            country: ['ES', Validators.required],
            firstName: ['', Validators.required],
            surname1: ['', Validators.required],
            surname2: [''],
            birthday: ['', Validators.required],
            sex: [''],
            company: [''],
            tipoVia: ['', Validators.required],
            nombreVia: ['', Validators.required],
            numero: ['', Validators.required],
            planta: [''],
            puerta: [''],
            escalera: [''],
            codigoPostal: ['', Validators.required],
            localidad: ['', Validators.required],
            provincia: ['', Validators.required],
            phone: ['', [
                Validators.required,
                Validators.pattern('[0-9 ]*'),
                Validators.minLength(9),
                Validators.maxLength(9)
            ]],
            email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
            email_confirm: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
            bank_account: [''],
            account_doctype: ['', Validators.required],
            account_doc: ['', Validators.required],
            account_country: ['', Validators.required],
            account_firstName: ['', Validators.required],
            account_surname1: ['', Validators.required],
            account_surname2: [''],
            sponsor: [''],
            account_company: [''],
        }, {
            validator: MustMatch('email', 'email_confirm')
        });
        
        this.confirmacionFormGroup = this.formBuilder.group({
            fourthCtrl: ['', Validators.required]
        });

        // Componentes
        this.normalizadorFormGroup = this.formBuilder.group({
            tipoViaNormaliza: ['', Validators.required],
            nombreViaNormaliza: ['', Validators.required],
            numeroNormaliza: ['', Validators.required],
            codigoPostalNormaliza: ['', Validators.required],
            localidadNormaliza: ['', Validators.required],
            provinciaNormaliza: ['', Validators.required]
        });

        this.coberturaFormGroup = this.formBuilder.group({
            localidadCobertura: ['', Validators.required],
            direccionesCobertura: ['', Validators.required],
            tipoViaCobertura: ['', ''],
            nombreViaCobertura: ['', ''],
            numeroCobertura: ['', ''],
            provinciaCobertura: ['', ''],
            codigoPostalCobertura: ['', ''],
            plantaCobertura: ['', Validators.required],
            bisCobertura: [null, ''],
            bloqueCobertura: [null, ''],
            portalCobertura: [null, ''],
            escaleraCobertura: [null, ''],
            tipoPuertaCobertura: [null, ''],
            puertaCobertura: [null, ''],
            resultadoConsultaCobertura: ['', ''],
            numeroApartamento: ['']
        });
    }

    listenDraftServices() {
        this.allSubscription.push(this.draftService.getMobilePackForms()
            .subscribe((arrayForms) => {
                if (arrayForms.length) {
                    this.movilPackForms = this.formBuilder.array(arrayForms);
                    this.movilPackFormGroup = this.formBuilder.group({
                        form: this.movilPackForms
                    });
                }
            })
        );
    }

    defineTypeOrder() {
        if (this.router.url === '/republica-movil/convergente') {
            this.rmService.setTypeOrder(orderType.CONVERGENT);
        } else if (this.router.url === '/republica-movil/solo-fibra') {
            this.rmService.setTypeOrder(orderType.BROADBAND);
        } else {
            this.rmService.setTypeOrder(orderType.MOBILE);
        }
    }

    getMasters() {
        this.rmService.getCommonRoadTypesFromService()
            .subscribe((data: any) => {
                this.rmService.setCommonRoadTypes(data.msg);
            });

        this.rmService.getProvincesAmenaFromService()
            .subscribe((data: any) => {
                this.rmService.setProvincesAmena(data.msg);
            });

        this.rateService.getRatesFromService()
            .subscribe((data: any) => {
                this.rateService.setRates(data.msg);
            });

        this.rmService.getMasterAllFromService()
            .subscribe((data: any) => {
                if (data && data.msg) {
                    this.rmService.setMasterAll(data.msg);
                    this.rmService.setDocumentTypes(data.msg.document_types);
                    this.rmService.setServiceProviders(data.msg.service_providers);
                    this.rmService.setCountries(data.msg.countries);
                    this.rmService.setProvinces(data.msg.provinces);
                    this.rmService.setRoadTypes(data.msg.road_types);
                }                
            }, (error) => {
                if (error && error.error && error.error.error && error.error.error.errorCode !== null && (error.error.error.errorCode === 462 || error.error.error.errorCode === 1007)) {
                    this.dialog.open(UserNotFoundComponent, {
                        width: '350px',
                        disableClose: true,
                        data: {
                            marca: 'República móvil'
                        }
                    });
                }
            });
    }

    setMobilePack() {
        return this.formBuilder.group({
            type_operation: ['registration', Validators.required],
            rate: ['', Validators.required],
            portability_phone: [''],
            portability_operator: [''],
            portability_type_client: [''],
            portability_iccid: [''],
            portability_client: [''],
            portability_date: [''],
            iccid: ['', [Validators.required, iccidValidator(this.digoService)]],
            terminal: [''],
            terminal_payment_type: [''],
            terminal_insurance: [''],
            stepper_index: [''],
            sponsor: ['']
        }, {
            validators: [NotMustMatch('iccid', 'portability_iccid'), NotMustMatch('portability_iccid', 'iccid')]
        });
    }

    addMobilePack() {
        if (this.movilPackForms.length <= this.maxAdditionalRates) {
            this.movilPackForms.push(this.setMobilePack());
        }
        this.movilPackService.setAllowAddAdditionalLines(this.movilPackForms.length < this.maxAdditionalRates);
    }

    removeAdditionalLine(index) {
        if (index !== 0) {
            this.stepper.previous();
            this.movilPackForms.removeAt(index);
        }
        this.movilPackService.setAllowAddAdditionalLines(this.movilPackForms.length < this.maxAdditionalRates);
    }

    priceConvergent(ftthAmount: number, discount?: number, mobileAmount?: number): number {
        let price = ftthAmount;
        if (mobileAmount != null) {
            price += mobileAmount;
            if (discount != null) {
                price -= discount;
            }
        }
        return price * 1.21;
    }

    priceWithIVA(val: number): number {
        return val * 1.21;
    }

    changeRate() {
        this.rate = null;

        if (this.typeOrder === orderType.CONVERGENT && this.mobileRates.length > 0) {
            this.rmService.removeFirstRatesMobile();
        }

        this.fibraFormGroup.get('rate').patchValue(null);
    }

    next() {
        if (this.fibraFormGroup.valid) {
            this.stepper.next();
        }
    }

    onStepChange() {
        if (!(this.pdv && this.pdv.permissions && this.pdv.permissions.SAMPLE_MODE && this.pdv.permissions.SAMPLE_MODE === 'SAMPLE')) {
            this.confirmationService.setDisableActivate(true);
            let info = {
                trace: this.stepper.selectedIndex + (navigator ? ('/' + navigator.userAgent) : ''),
                timestamp: new Date().toISOString()
            }
            this.orderService.createOrder(true, info)
                .subscribe((data: any) => {
                    this.orderService.setOrderId(data.msg.orderId);
                    this.confirmationService.setDisableActivate(false);
                }, error => {
                    console.error('[CREATE ORDER]', error);
                    this.confirmationService.setDisableActivate(false);
                });
        }
    }

    onActivationRequest(event) {
        this.isEditable = event;
    }

    // metodo que llamamos antes de guardar un borrador, debeía meter todo al order aunque esté a medias
    updateOrderWithLastChanges() {
        if (this.typeOrder !== orderType.BROADBAND) {
            for (const [index, mobileForm] of this.movilPackForms.controls.entries()) {
                this.rmService.setMobilePacks(index, (mobileForm as FormGroup).getRawValue());
            }
        }

        this.userDataService.setUserData(this.clienteFormGroup.getRawValue());
    }

    goToAmenaConvergente() {
        // this.rmService.setPreventDestroy(true);
        this.amNormalizadorService.setResultadoCobertura(this.resultadoCoberturaAmena);
        this.amNormalizadorService.setMuestraNormalizacion(false);
        this.amNormalizadorService.setMuestraCobertura(false);
        this.amNormalizadorService.setErrorPeticionCobertura(false);

        this.router.navigate(['amena/convergente']);
    }

    goToHomeRates() {
        // this.rmService.setPreventDestroy(true);
        this.homeService.setViewBrandRates('am');
        this.hmRateService.setFilterRatesByType(this.orderType.CONVERGENT);
        this.router.navigate(['/']).then(() => this.normalizadorService.resetNormalizacion());
    }

    ngOnDestroy() {
        console.log('DESTROY RM COMPONENT');
        if (!this.preventDestroy) {
            // Reiniciamos formularios
            this.fibraFormGroup.reset();
            this.movilPackForms.reset();
            this.movilPackFormGroup.reset();
            this.clienteFormGroup.reset();
            this.confirmacionFormGroup.reset();
            this.normalizadorFormGroup.reset();
            this.coberturaFormGroup.reset();
            // Reiniciamos varaibles de control
            this.isLoading = false;
            this.isEditable = true;
            this.finished = false;
            this.typeOrder = '';
            // Reiniciamos normalización
            this.normalizadorService.resetNormalizacion();
            this.normalizadorService.setErrorPeticionCobertura(false);
            // Reiniciamos pedido
            this.orderService.resetOrder();
            this.rmService.setRateFtth(null);
            this.rmService.resetMobile();
            this.confirmationService.setFinished(false);
            this.rmService.setTypeOrder(null);
            this.rmService.setFormsData(null);
            
            if (this.stepper) {
                this.stepper.reset();
            }
            if (this.allSubscription && this.allSubscription.length) {
                this.allSubscription.map(subs => subs.unsubscribe());
            }
        }
    }
}
